/**
 * Copyright (c) 2018-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
import { Editor } from './components/Editor';
export default Editor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@tinymce_tinymce-vue@1.1.2@@tinymce/tinymce-vue/lib/es2015/index.js
// module id = null
// module chunks = 